/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claim_Requester_Customer_ServiceInputs */

const en_claim_requester_customer_service = /** @type {(inputs: Claim_Requester_Customer_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customer Service`)
};

/**
* | output |
* | --- |
* | "Customer Service" |
*
* @param {Claim_Requester_Customer_ServiceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const claim_requester_customer_service = /** @type {((inputs?: Claim_Requester_Customer_ServiceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claim_Requester_Customer_ServiceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_claim_requester_customer_service(inputs)
});